module.exports = __webpack_public_path__ + "img/youtube-icon.a0241113.svg";